/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Machine-readable reason an authenticated caller was refused by an access gate. Clients branch on this value, never on the bare HTTP status. app_access_denied: hasAppAccess refused survey-only staff (super.survey_upload_manager without super.admin) on an ordinary app route. admin_panel_access_denied: hasAdminPanelAccess refused a caller holding neither super.admin nor super.survey_upload_manager.
 */
export enum AccessDeniedErrorCode {
    APP_ACCESS_DENIED = 'app_access_denied',
    ADMIN_PANEL_ACCESS_DENIED = 'admin_panel_access_denied',
}
